@if (!!document) {
  <topo-modal
    [isActive]="!!document"
    [isCard]="true"
    [rawHeight]="'75vh'"
    (close)="close()">
    <div class="modal-header header">
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center">
        <div
          class="header"
          fxLayout="row"
          fxLayoutAlign="start center">
          <div class="title">{{ title }}</div>
        </div>
        <div
          fxLayout="row"
          fxLayoutAlign="end center"
          class="save-buttons">
          <div
            class="dialog-close header-close"
            (click)="close()">
            <i class="icon icon-close-X"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-body">
      <div class="log-detail">
        @if (hasFilter === true) {
          <div>
            <div class="filters-container">
              <label>{{ 'COMMUNICATIONS.FILTERS' | translate }}</label>
              <topo-filter-display
                style="width: 100%"
                [filterGroup]="filterGroup"
                [schema]="dataset?.schema"
                [workflow]="dataset?.workflow"
                [disabled]="true"
                [showInstructions]="false"
                actionIfDescription=" "
                actionResultDescription=" "
              [maxLength]="0"></topo-filter-display>
            </div>
            <div>
              <ng-container
                topoDynamicForm2
                (valueChanged)="valueChanged($event)"
                [formView]="editView"
                [schema]="dataset?.schema"
                [layerUId]="null"
                [document]="filterDocument"
                [controlCollection]="documentControls"
                [viewContainer]="selectedViewContainer"
                [isEdit]="false"
              [dataset]="dataset"></ng-container>
            </div>
          </div>
        }
        @if (hasTime === true) {
          <div>
            <div class="field">
              <label>{{ 'COMMUNICATIONS.NOTIFICATION-TIME' | translate }}</label>
              <div>{{ runTime }}</div>
            </div>
            <div class="field">
              <label>{{ 'COMMUNICATIONS.DO-NOT-DISTURB-FROM-HOUR' | translate }}</label>
              <div>{{ fromHour }}:00</div>
            </div>
            <div class="field">
              <label>{{ 'COMMUNICATIONS.DO-NOT-DISTURB-TO-HOUR' | translate }}</label>
              <div>{{ toHour }}:00</div>
            </div>
          </div>
        }
        @if (hasAddress === true) {
          <div>
            <div class="field">
              <label>{{ 'COMMUNICATIONS.NOTIFICATION-SEVERITY' | translate }}</label>
              <div>{{ severity }}</div>
            </div>
            <div class="field">
              <label>{{ 'COMMUNICATIONS.COLUMNS.ADDRESS' | translate }}</label>
              <div>{{ address }}</div>
            </div>
          </div>
        }
        @if (hasGenericInfo) {
          <div>
            <div class="generic-info"
              fxLayout="row"
              fxLayoutAlign="center center">
              <div>{{ genericStatus }}</div>
            </div>
          </div>
        }
        @if (hasNoInfo) {
          <div>
            <div class="no-info"
              fxLayout="row"
              fxLayoutAlign="center center">
              {{ 'COMMUNICATIONS.NO-DETAILS' | translate }}
            </div>
          </div>
        }
      </div>
    </div>
    <div class="modal-footer">
      <div
        fxLayout="row"
        fxLayoutAlign="space-between center"
        class="mt-4 mb-4">
        <div></div>
        <div fxLayoutAlign="start">
          <div style="margin-right: 5px">
            <button
              class="button is-secondary"
              (click)="close()">
              {{ 'COMMUNICATIONS.BUTTONS.CLOSE' | translate }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </topo-modal>
}
